// rg-hide-low-badges: oculta en TODO el sitio (colecciones, home, búsqueda,
// no solo la ficha del producto) la píldora nativa de Judge.me
// (".jdgm-prev-badge") cuando el puntaje no llega al mínimo de 4 estrellas
// que ya usamos para las reseñas propias (MIN_RATING en rg-reviews-tiers.js)
// -- mismo criterio, aplicado también a esta píldora que Judge.me pone sola,
// fuera de nuestro widget, en cualquier tarjeta de producto o ficha.
//
// 2026-10-02: antes esto vivía solo dentro de rg-reviews-tiers.js, y solo se
// aplicaba en la ficha del producto cuando entraba en modo "respaldo" (sin
// reseñas propias). Reportado por el usuario: la misma píldora de 3★ seguía
// viéndose en las tarjetas de colección/grilla, porque esas páginas nunca
// cargan rg-reviews-tiers.js (solo se carga vía bloque en product*.json e
// index.json, no en collection.json/search.json). Se saca a un script propio,
// cargado global en el layout, para que corra en cualquier página.
(function () {
  var MIN_RATING = 4;

  function run() {
    var badges = document.querySelectorAll('.jdgm-prev-badge');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      var avg = parseFloat(b.getAttribute('data-average-rating'));
      var n = parseInt(b.getAttribute('data-number-of-reviews'), 10);
      // Judge.me aplica su propio display:block con !important en su CSS --
      // una asignación normal de .style.display no le gana.
      if (n > 0 && !isNaN(avg) && avg < MIN_RATING) {
        b.style.setProperty('display', 'none', 'important');
      }
    }
  }

  function start() {
    run();

    // rg: mismo observer compartido que rg-reviews-toggle.js / rg-barra-envio.js
    // / sections/main-cart.liquid -- Judge.me reconstruye su DOM mas de una vez
    // despues de la carga inicial, asi que esto reacciona en vez de aplicarse
    // una sola vez.
    if (!window.__rgObservarCambiosDom) {
      window.__rgDomWatchers = [];
      window.__rgObservarCambiosDom = function (fn) { window.__rgDomWatchers.push(fn); };
      new MutationObserver(function (mutaciones) {
        window.__rgDomWatchers.forEach(function (fn) { fn(mutaciones); });
      }).observe(document.body, { childList: true, subtree: true });
    }

    var debounceTimer = null;
    window.__rgObservarCambiosDom(function () {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(run, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
